export default {"src":"/_next/static/media/icon_04.9418d1bc.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};